import { useEffect, useRef, useState } from "react";

export default function Portfolio() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="work" ref={sectionRef} className="py-24 md:py-36 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className={`mb-16 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4 block">Our Work</span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-950 leading-tight">
            Selected<br />
            <span className="italic font-light text-gray-400">Case Studies</span>
          </h2>
        </div>

        {/* Coming Soon Placeholder */}
        <div className={`transition-all duration-700 delay-200 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="bg-white rounded-3xl border border-gray-200 p-16 md:p-24 flex flex-col items-center justify-center text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-gray-100 rounded-full mb-6">
              <i className="ri-time-line text-2xl text-gray-400"></i>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">Coming Soon</h3>
            <p className="text-gray-500 max-w-md text-sm md:text-base leading-relaxed">
              We are currently working on documenting our latest projects. Check back soon for detailed case studies showcasing our work.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-14 text-center">
          <button
            onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
            className="inline-flex items-center gap-2 border border-gray-300 text-gray-700 text-sm font-semibold px-8 py-4 rounded-full hover:bg-gray-950 hover:text-white hover:border-gray-950 transition-all cursor-pointer whitespace-nowrap"
          >
            Work With Us
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
